


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IconSoldOut extends Vue {
  @Prop({default: 4}) public readonly width!: number;
  @Prop({default: 21}) public readonly height!: number;
  @Prop({default: '#1A9143'}) public color!: string;
}
